export default __webpack_public_path__ + "b13966aebac74ec6232836259a1d1214.png";